module.exports = __webpack_public_path__ + "img/big-indent--primary.edd05e69.svg";